import { WsMessageEvent } from "../utils/wsModule";
import { BufferLike } from "../utils/websocketModifier.util";
import { decodeTransfer, encodeTransfer } from "../transfer";
import { CompressResolver } from "./index";

export default class NoCompressionResolver extends CompressResolver {
	public static typeName(): string {
		return "NoCompression";
	}

	public async compress(messageEvent: object): Promise<BufferLike> {
		return encodeTransfer(messageEvent, {
			transfer: this.options.transfer,
			sessionId: this.options.session.sessionId,
		});
	}

	public async decompress(messageEvent: WsMessageEvent): Promise<object> {
		let data = messageEvent.data;
		if (typeof Blob !== "undefined" && data instanceof Blob) {
			data = new Uint8Array(await data.arrayBuffer());
		}
		return decodeTransfer(data as any, {
			transfer: this.options.transfer,
			sessionId: this.options.session.sessionId,
		});
	}
}
